import type { FocusMethod, FocusMethodConfig, MethodSession } from './types';

export const PomodoroMethod: FocusMethod = {
  buildQueue({
    workDuration,
    shortBreakDuration,
    longBreakDuration,
    longBreakInterval,
    pomodoroCount,
    currentTab,
  }: FocusMethodConfig): MethodSession[] {
    const sessions: MethodSession[] = [];
    let count = pomodoroCount;
    let next = currentTab;

    for (let i = 0; i < 5; i++) {
      if (next === 'pomodoro') {
        count++;
        next = count % longBreakInterval === 0 ? 'longBreak' : 'shortBreak';
      } else {
        next = 'pomodoro';
      }
      const durationSeconds =
        next === 'pomodoro' ? workDuration * 60
        : next === 'shortBreak' ? shortBreakDuration * 60
        : longBreakDuration * 60;
      sessions.push({ type: next as MethodSession['type'], durationSeconds });
    }

    return sessions;
  },
};
